import { PLAN_IDS } from '~/constants';

const getPlanId = (plan) => {
  let planId = null;
  switch (plan) {
    case 'pro':
      planId = PLAN_IDS.PRO_PLAN_ID;
      break;
    case 'solo_premium_business':
      planId = PLAN_IDS.SOLO_PREMIUM_BUSINESS_PLAN_ID;
      break;
    case 'premium_business':
      planId = PLAN_IDS.PREMIUM_BUSINESS_PLAN_ID;
      break;
    case 'small':
      planId = PLAN_IDS.SMALL_PLAN_ID;
      break;
    default:
      break;
  }
  return planId;
};

export { getPlanId };
